import {createSlice} from '@reduxjs/toolkit';
import {DavisUserLink} from '../../api/types';

type Props = {
  link: DavisUserLink | null;
};

export const davisSlice = createSlice({
  name: 'davis',
  initialState: {
    link: null,
  } as Props,
  reducers: {
    setDavisUserLink: (state, {payload: link}: {payload: DavisUserLink}) => {
      if (state.link === null || link === null) {
        state.link = link;
      } else {
        // mergeDeep in order to keep generic_station key which is not present for station list
        const oldWeatherStations = state.link.account.weather_stations;
        const newWeatherStations = link.account.weather_stations;

        state.link = link;
        const mergedWeatherStations = [];
        newWeatherStations.forEach((newItem) => {
          const oldStation = oldWeatherStations.find(
            (oldItem) => oldItem.device_id === newItem.device_id,
          );
          if (oldStation) {
            mergedWeatherStations.push({...oldStation, ...newItem});
          } else {
            mergedWeatherStations.push(newItem);
          }
        });
        state.link.account.weather_stations = mergedWeatherStations;
      }
    },
  },
});

export const {setDavisUserLink} = davisSlice.actions;

export default davisSlice.reducer;
